export default __webpack_public_path__ + "static/media/indexxPaypalForWhiteMode.be80d64d.svg";